import { HTMLAttributes } from "react";
import { DropzoneOptions, useDropzone } from "react-dropzone";
import { BiCloudUpload } from "react-icons/bi";

export interface DragDropProps extends HTMLAttributes<HTMLDivElement> {
    text: string;
    textHover: string;
    onDropFile?: DropzoneOptions["onDrop"];
}

const DragDrop = (props: DragDropProps) => {
    const { text, textHover, onDropFile, ...rest } = props;
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop: onDropFile,
        accept: {
            "audio/mp3": [".mp3"],
            "audio/wma": [".wma"],
            "audio/wav": [".wav"],
        },
    });
    return (
        <div {...rest} {...getRootProps({ accept: "mp3/*" })}>
            <div className="tw-text-center tw-cursor-pointer">
                <BiCloudUpload className="upload-icon" size={70} />
            </div>
            <input className="input-zone" {...getInputProps()} />
            <div className="tw-text-center tw-cursor-pointer">
                <p className="dropzone-content tw-text-2xl tw-font-extrabold">
                    {isDragActive
                        ? textHover
                        : text}
                </p>
            </div>
        </div>
    )
}

export default DragDrop;